/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
import React from 'react'
import { ShimmerBadge,
    ShimmerButton,
    ShimmerTitle,ShimmerThumbnail,ShimmerSectionHeader, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'

export default function ViewSkeleton({Type}) {
    return (
        <>
            <div class="mainDataCntnrTop shadow-s13 flex items-center">
                <div class="flex items-center">
                    <h5 class="pageHeader adderror">{Type} Profile</h5>
                </div>            
            </div>
            <div class="px-10 pt-4 pb-10">
                <div class="mt-2">
                    <div class=" opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block" id="tabs-institutionDetails" role="tabpanel" aria-labelledby="tabs-institutionDetails-tab">
                        <div class="w-[85%] mx-auto">
                            <div class="flex justify-end">
                            </div>
                            <div class=" p-4 mt-1">
                                <div class="flex -mx-2">
                                    <div class="w-[60%] px-2">
                                        <div class="w-full">
                                            <h5 class="text-f7 font-semibold text-[#000000] break-words"><ShimmerBadge width={200}/></h5>
                                            <div class="flex items-start mt-2">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={60}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={100}/></p>
                                                </div>
                                            </div>
                                            <div class="flex items-start mt-4">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words truncate"><ShimmerBadge width={200}/></p>
                                                </div>
                                            </div>
                                            <div class="flex items-center mt-4">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={200}/></p>
                                                </div>
                                            </div>
                                        </div>           
                                    </div>
                                    <div class="w-[40%] px-2">
                                        <div class="w-full">
                                            <h5 class="text-f7 font-semibold text-[#000000] break-words"><ShimmerBadge width={200}/></h5>
                                            <div class="flex items-start mt-2">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={60}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={100}/></p>
                                                </div>
                                            </div>
                                            <div class="flex items-start mt-4">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words truncate"><ShimmerBadge width={200}/></p>
                                                </div>
                                            </div>
                                            <div class="flex items-center mt-4">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={200}/></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                </div>
            </div>
            <div class="px-10 pt-4 pb-10">
                <div class="mt-2">
                    <div class=" opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block" id="tabs-institutionDetails" role="tabpanel" aria-labelledby="tabs-institutionDetails-tab">
                        <div class="w-[85%] mx-auto">
                            <div class="flex justify-end">
                            </div>
                            <div class=" p-4 mt-1">
                                <div class="flex -mx-2">
                                    <div class="w-[60%] px-2">
                                        <div class="w-full">
                                            <h5 class="text-f7 font-semibold text-[#000000] break-words"><ShimmerBadge width={200}/></h5>
                                            <div class="flex items-start mt-2">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={60}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={100}/></p>
                                                </div>
                                            </div>
                                            <div class="flex items-start mt-4">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words truncate"><ShimmerBadge width={200}/></p>
                                                </div>
                                            </div>
                                            <div class="flex items-center mt-4">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={200}/></p>
                                                </div>
                                            </div>
                                        </div>           
                                    </div>
                                    <div class="w-[40%] px-2">
                                        <div class="w-full">
                                            <h5 class="text-f7 font-semibold text-[#000000] break-words"><ShimmerBadge width={200}/></h5>
                                            <div class="flex items-start mt-2">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={60}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={100}/></p>
                                                </div>
                                            </div>
                                            <div class="flex items-start mt-4">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words truncate"><ShimmerBadge width={200}/></p>
                                                </div>
                                            </div>
                                            <div class="flex items-center mt-4">
                                                <p class="text-f7 font-normal text-[#031624] min-w-[130px]"><ShimmerBadge width={100}/></p>
                                                <div class="flex items-center">
                                                    <p class="text-f7 font-semibold text-[#031624] break-words"><ShimmerBadge width={200}/></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        
                </div>
            </div>
        </>
    )
}
